import { create } from 'zustand';

interface Modal {
  content: any | any[] | null;
  props: object | null;
}

const modal: Modal = {
  content: null,
  props: null,
};

const secondaryModal: Modal = {
  content: null,
  props: null,
};

interface ModalStore {
  modal: Modal;
  secondaryModal: Modal;
  openModal: (content: any[] | any, props: object | null) => void;
  openSecondaryModal: (content: any[] | any, props: object | null) => void;
  closeModal: () => void;
  closeSecondaryModal: () => void;
}

export const useModal = create<ModalStore>((set) => ({
  modal: modal,
  secondaryModal: secondaryModal,
  openModal: (content, props) => set(() => ({ modal: { content, props } })),
  openSecondaryModal: (content, props) => set(() => ({ secondaryModal: { content, props } })),
  closeModal: () => set(() => ({ modal: { content: null, props: null } })),
  closeSecondaryModal: () => set(() => ({ secondaryModal: { content: null, props: null } })),
}));
